// extracted by mini-css-extract-plugin
export default {"card":"FormatSelector_card__HU4gg","thumbnail":"FormatSelector_thumbnail__32z3B","downloads":"FormatSelector_downloads__X8DRK","buttonWrapper":"FormatSelector_buttonWrapper__pJm2N"};